import { useMutation, useQueryClient } from "@tanstack/react-query";
import { client } from "@/lib/hono";
import toast from "@/lib/toast";
import { t } from "@/lib/localization";

export const useUpdateAvatar = () => {
    const qc = useQueryClient();
    return useMutation<
        unknown,
        Error,
        { id: string; name: string }
    >({
        mutationKey: ["updateAvatar"],
        mutationFn: async ({ id, name }) => {
            const response = await client.api.avatars.heygen.avatars[":id"]["update"].$post({
                param: { id },
                json: { name },
            });
            if (!response.ok) throw new Error("Failed to rename avatar");
            return await response.json();
        },
        onSuccess: (_data, { id }) => {
            toast.success(t("avatars.toast.rename-avatar.success"), {
                keyName: "toast.success.rename-avatar",
            });
            qc.invalidateQueries({ queryKey: ["avatars"] });
            qc.invalidateQueries({ queryKey: ["avatar", id] });
        },
        onError: () => {
            toast.error(t("avatars.toast.rename-avatar.error"), {
                keyName: "avatars.toast.rename-avatar.error",
            });
        },
    });
};
